import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n';

export function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas p-4">
      <div className="w-full max-w-md text-center">
        <div className="text-8xl font-bold text-line-strong mb-4">
          404
        </div>
        <h1 className="text-2xl font-bold text-ink mb-2">
          {t('not_found.title')}
        </h1>
        <p className="text-ink-2 mb-8">
          {t('not_found.message')}
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-brand text-white rounded-xl font-semibold hover:bg-brand-2 transition-colors"
        >
          {t('not_found.go_home')}
        </button>
      </div>
    </div>
  );
}
